import { useQuery } from "@tanstack/react-query";
import { searchCompaniesByName } from "@/api";
import { CompanyInfoFractal } from "@/types";

export const useSearchedCompanies = (name?: string) => {
  const query = useQuery<CompanyInfoFractal[]>({
    queryKey: ["searchedCompanies", name],
    queryFn: () => searchCompaniesByName(name!),
    staleTime: 1000 * 60 * 5,
    enabled: !!name && name.length >= 2,
  });

  return {
    ...query,
    data: query.data || [],
  }
};